// extracted by mini-css-extract-plugin
export var button = "counter-module--button--b2c53";
export var counter = "counter-module--counter--a5642";
export var number = "counter-module--number--d0cde";